import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDollarComponent } from "./med-icon-dollar.component";

@NgModule({
  declarations: [
    MedIconDollarComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDollarComponent,
  ],
})
export class MedIconDollarModule { }
